var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2F3440;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#2F3440;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#DD7E43;}\r\n\t.st5{fill:#DD7E43;}\r\n\t.st6{fill:#DD7E43;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.65,48.65L78.82,35.81V20.98c0-2.68-2.17-4.85-4.86-4.85c-2.68,0-4.85,2.17-4.85,4.85v5.12l-9.56-9.56 c-4.73-4.72-12.94-4.72-17.66,0.01l-32.1,32.1c-1.89,1.9-1.89,4.97,0,6.87c1.9,1.9,4.97,1.9,6.87,0l32.1-32.1 c1.05-1.04,2.89-1.04,3.93,0l32.1,32.1c0.95,0.95,2.19,1.42,3.43,1.42c1.24,0,2.49-0.47,3.44-1.42 C93.55,53.62,93.55,50.55,91.65,48.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.41,32.63c-0.93-0.93-2.44-0.93-3.37,0L20.8,60.86c-0.45,0.45-0.7,1.05-0.7,1.69v20.59 c0,4.83,3.92,8.75,8.75,8.75h13.98V70.23h15.78v21.65h13.98c4.83,0,8.75-3.92,8.75-8.75V62.54c0-0.63-0.25-1.24-0.7-1.69 L52.41,32.63z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.7a4e4738673689b0dffc0fb6311e0f4b.svg";
export { ForwardRef as ReactComponent };